/* CUSTOM_ROCKETWEBHOOK_BY_CLAUDE (ONYX f4f90d92ce56, Ryan 2026-10-14)
   Settings -> Admin: GoRocket Tracking Webhook - the JS half. Markup in snippets/rep-settings-rocket-webhook.liquid.
   GET /admin/rocket-webhook (the address, the switch, the last 20 posts), POST /admin/rocket-webhook {enabled?, rotate?}.
   Save stays disabled until the page has read the current setting. */
(function () {
  'use strict';
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  }
  var OUTCOME = {
    'switch-off': 'logged only (switched off)', 'no-load-number': 'no load number in the post', 'no-deal': 'load is on no deal we know',
    'not-json': 'not JSON', checked: 'read from GoRocket', threw: 'error',
    'refused-signature': 'refused: signature check failed', // CUSTOM_ROCKETSIG_BY_CLAUDE
  };
  /* CUSTOM_ROCKETSIG_BY_CLAUDE (ONYX 73e770c3c1b1, Ryan 2026-10-16) - what the signature check said about each post. */
  var SIGNED = { valid: 'good', absent: 'unsigned', stale: 'too old', invalid: 'BAD', 'no-secret': 'not checked' };
  function hitsHtml(hits) {
    if (!hits || !hits.length) return '<p style="color: var(--rq-text-secondary);">No posts from GoRocket yet.</p>';
    return '<table style="border-collapse: collapse; font-size: 12px;"><thead><tr>'
      + ['When', 'Load', 'Deal', 'GoRocket says', 'Signature', 'Result', 'Woke'].map(function (h) { return '<th style="text-align:left; padding-right: 12px;">' + h + '</th>'; }).join('')
      + '</tr></thead><tbody>' + hits.map(function (h) {
        var res = OUTCOME[h.outcome] || h.outcome || '';
        return '<tr><td style="padding-right: 12px;">' + esc(h.at ? new Date(h.at).toLocaleString() : '') + '</td><td style="padding-right: 12px;">' + esc(h.loadNumber || '-')
          + '</td><td style="padding-right: 12px;">' + esc(h.ref || '-') + '</td><td style="padding-right: 12px;">' + esc(h.rocketStatus || h.said || '-')
          + '</td><td style="padding-right: 12px;">' + esc(h.signed ? (SIGNED[h.signed] || h.signed) : '-')
          + '</td><td style="padding-right: 12px;">' + esc(res) + (h.change ? ' (' + esc(h.change) + ')' : '') + '</td><td>' + esc(h.woke || '') + '</td></tr>';
      }).join('') + '</tbody></table>';
  }
  function showMsg(el, text, type) {
    if (!el) return;
    el.textContent = text;
    el.className = 'rep-settings__message rep-settings__message--visible rep-settings__message--' + type;
  }
  function init() {
    if (!window.RepPortal || !window.RepPortal.API) return;
    var api = window.RepPortal.API;
    var urlBox = document.getElementById('settings-rocketwebhook-url');
    var enabled = document.getElementById('settings-rocketwebhook-enabled');
    var refuse = document.getElementById('settings-rocketwebhook-refuse'); // CUSTOM_ROCKETSIG_BY_CLAUDE
    var save = document.getElementById('settings-rocketwebhook-save');
    var copy = document.getElementById('settings-rocketwebhook-copy');
    var rotate = document.getElementById('settings-rocketwebhook-rotate');
    var msg = document.getElementById('settings-rocketwebhook-msg');
    var hits = document.getElementById('settings-rocketwebhook-hits');
    if (!save || !urlBox) return;
    function apply(d) {
      if (d.url) urlBox.value = d.url;
      enabled.checked = d.enabled === true;
      if (refuse) refuse.checked = d.refuseBadSignature === true;
      if (d.hits) hits.innerHTML = hitsHtml(d.hits);
    }
    (async function load() {
      try { apply(await api.get('/admin/rocket-webhook')); save.disabled = false; }
      catch (e) { showMsg(msg, 'Could not load the current setting - reload before saving.', 'error'); }
    })();
    save.addEventListener('click', async function () {
      save.disabled = true;
      try { var r = await api.post('/admin/rocket-webhook', { enabled: !!enabled.checked, refuseBadSignature: !!(refuse && refuse.checked) }); apply(r); showMsg(msg, r.meaning || 'Saved.', 'success'); }
      catch (e) { showMsg(msg, 'Could not save: ' + (e && e.message ? e.message : 'unknown error'), 'error'); }
      finally { save.disabled = false; }
    });
    copy.addEventListener('click', function () {
      urlBox.select();
      try { navigator.clipboard.writeText(urlBox.value); showMsg(msg, 'Copied.', 'success'); } catch (e) { document.execCommand('copy'); }
    });
    rotate.addEventListener('click', async function () {
      if (!window.confirm('Make a new address? The current one stops working at once, so Jarrod will need the new one.')) return;
      try { var r = await api.post('/admin/rocket-webhook', { rotate: true }); apply(r); showMsg(msg, r.meaning || 'New address made.', 'success'); }
      catch (e) { showMsg(msg, 'Could not make a new address: ' + (e && e.message ? e.message : 'unknown error'), 'error'); }
    });
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = { hitsHtml: hitsHtml };
  if (typeof document === 'undefined') return;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
/* END CUSTOM_ROCKETWEBHOOK_BY_CLAUDE */
